import React from 'react';
import { Typography } from 'shared/components';
import { useIntl } from 'react-intl';

export const StatisticTitle = () => {
  const { formatMessage } = useIntl();
  return (
    <Typography variant="subtitle1">
      <b>{formatMessage({ id: 'statistic' })}:</b>
    </Typography>
  );
};
